<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" width="15.454" height="16.078" viewBox="0 0 15.454 16.078" v-on="$listeners">
        <g id="noun_Download_2678112" transform="translate(-33.389 -32.71)">
            <g id="Groupe_3066" data-name="Groupe 3066" transform="translate(33.539 32.86)">
                <path id="Tracé_3206" data-name="Tracé 3206" d="M45.455,44.342a.69.69,0,0,0,.976,0l2.77-2.77a.69.69,0,1,0-.976-.976l-1.591,1.592V33.551a.69.69,0,1,0-1.381,0v8.637L43.661,40.6a.69.69,0,0,0-.976.976Z" transform="translate(-38.366 -32.86)" :fill="color"/>
                <path id="Tracé_3207" data-name="Tracé 3207" d="M48,46.217a.691.691,0,0,0-.69.69v7.559H34.92V46.907a.69.69,0,1,0-1.381,0v8.25a.69.69,0,0,0,.69.69H48a.691.691,0,0,0,.69-.69v-8.25A.691.691,0,0,0,48,46.217Z" transform="translate(-33.539 -40.069)" :fill="color"/>
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconDownload',
    mixins: [Colorable],
};
</script>
